<template>
  <div id="tela-selfie">
    <div class="captura" :class="{'hidden':isError}">
      <div id="selfie"></div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="this.reloadComponent"
      ></Error>
    </div>
  </div>
</template>

<script>

import Error from "../shared/Error";
import DispatchTags from "../../utils/DispatchTags";
import LivenessLogService from '../../services/LivenessLogService';

const ERROR = {
  title: "Não conseguimos tirar a foto do seu rosto",
  subtitle: "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente",
  btnTitle: "Tentar novamente",
};

const ERROR_ACESSO_CAMERA = {
  title: "Algo deu errado ao acessar sua câmera",
  subtitle: "Precisamos do acesso pra tirar a foto e confirmar sua identidade",
  btnTitle: "Permitir acesso à câmera",
};

export default {
  name: "Selfie",
  components: {Error},
  data(){
    return {
      isError: false,
      error: {
        title: ERROR.title,
        subtitle: ERROR.subtitle,
        btnTitle: ERROR.btnTitle
      },
      intervalCallack:null,
      logLiveness: null
    }
  },
  beforeRouteLeave(to, from,next) {
    this.pararDOMNodeInserted();
    next();
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", true);
  },
  mounted() {
    this.logLivenessService = new LivenessLogService();
    DispatchTags.dispatchScreenView("Selfie");
    var interval = setInterval(_ => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.selfie = window.selfie;
      this.iniciarSelfie();
      clearInterval(interval);
    }, 100);
  },
  methods:{
    iniciarSelfie:function (){
      this.iniciaCallback();
      this.iniciarDOMNodeInserted();
      let htmlElement = document.getElementById('selfie');
      this.selfie
          .iniciaSelfie(htmlElement,(objLog) => {
            //Callback que tem apenas o objeto de log
            let status = objLog.status === "sucesso" ? 1 : 2;
            let sessionId = objLog.sessionId;
            if(!sessionId && window.selfie.latestSessionResult){
              sessionId = window.selfie.latestSessionResult.sessionId;
            }
            this.logLivenessService.sendLogLiveness(status,
                                                    sessionId,
                                                    objLog.errorId,
                                                    objLog.errorMsg);
          })
          .then(res => {
            DispatchTags.dispatchNoninteraction("Selfie");
            this.$store.dispatch("setLoadingStatus", true);
            sessionStorage.setItem("s", 'data:image/jpeg;base64,'+res.selfie);
            this.nextPage();
          })
          .catch(e => {
            let sessionId = window.selfie.latestSessionResult
                ? window.selfie.latestSessionResult.sessionId
                : '';
            this.logLivenessService.sendLogLiveness(2,sessionId,e.id,e.desc);
            DispatchTags.dispatchScreenView('SelfieError');
            DispatchTags.dispatchNoninteraction('SelfieError');
            this.showError(null,e.desc);
          });
      //
    },
    iniciaCallback:function (){
      const idCallback = {
        LOADING: "loading",
        LIBERAR_CAMERA: "LIBERAR_CAMERA",
        CAPTURA_BIOMETRICA: "captura_biometrica",
        ERRO_RECOMENDACAO: "erro_recomendacao",
        SUCESSO: "sucesso ",
      };
      let previousValue = this.selfie.callbackID;

      this.intervalCallack = setInterval(() => {
        if (this.selfie.callbackID === previousValue) {
          return;
        }
        previousValue = this.selfie.callbackID;
        switch (this.selfie.callbackID){
          case idCallback.LOADING:
            //indica para apresentar o loading
            this.$store.dispatch("setLoadingStatus", true);
            break;
          case idCallback.CAPTURA_BIOMETRICA:
            //indica quando o componente inicia
            //o componente tem um delay até iniciar, e não indica quando devemos remover o loading
            //por isso foi utilizado o metodo iniciarDOMNodeInserted foi usado
            break;
          case idCallback.ERRO_RECOMENDACAO:
            //ação disparada quando usuario nega a permissão de camera
            let e = ERROR_ACESSO_CAMERA;
            this.acessoCamera = true;
            this.showError(e.title,e.subtitle,e.btnTitle);
            break;
          case idCallback.SUCESSO:
            //ação disparada no then, callback inutil
            break;
        }
      },100);
    },
    reloadComponent() {
      let tag = (this.acessoCamera) ? 'ModalCamera' : 'SelfieError';
      DispatchTags.dispatchInraction(tag);
      this.acessoCamera = false;
      this.$store.dispatch("setLoadingStatus", true);
      //o componente só volta funcionar caso de reload na pagina =D
      this.$router.replace({name:'ConfirmarIdentidade'}).then(_ => {
        this.$store.dispatch("setLoadingStatus", true);
        window.location.reload(true);
      });
    },
    nextPage(){
      this.clearIntervalCallback();
      let doc_a = sessionStorage.getItem("A");
      let doc_b = sessionStorage.getItem("B");
      let tipo_captura = this.$store.getters.tipoCaptura;
      let name = (tipo_captura === 1 && (!doc_a || !doc_b)) ?  "DocSelecao" : "Analise";
      this.$router.push({ name: name });
    },
    clearIntervalCallback(){
      if(this.intervalCallack){
        clearInterval(this.intervalCallack);
      }
    },
    showError(title,subtitle,btnTitle){
      if(this.isError){
        return;
      }
      this.clearIntervalCallback();
      this.error.title = title ? title : ERROR.title;
      this.error.subtitle = subtitle ? subtitle : ERROR.subtitle;
      this.error.btnTitle = btnTitle ? btnTitle : ERROR.btnTitle;
      this.isError = true;
      this.$store.dispatch("setLoadingStatus", false);
    },
    videoIniciou(){
      var cameraVideo = $('video');
      if (cameraVideo.length === 0) {
        return;
      }
      DispatchTags.dispatchNoninteraction("SelfieReady");
      this.$store.dispatch("setLoadingStatus", false);
    },
    iniciarDOMNodeInserted(){
      //quando um elemento video é inserido no dom chama a função videoIniciou
      this.observer = new MutationObserver(mutationList =>
          mutationList.filter(m => m.type === 'childList').forEach(m => {
            m.addedNodes.forEach(a => {
              if(a.nodeName.toLowerCase() == 'video'){
                this.pararDOMNodeInserted();
                this.videoIniciou();
              }
            });
          }));
      this.observer.observe(window.document.body,{childList: true, subtree: true});
    },
    pararDOMNodeInserted(){
      //para de observar quando o elemento video é inserido no dom
      this.observer.disconnect();
    },
  }
}
</script>

<style scoped>
.hidden{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Selfie.vue